import { defineMessages } from 'react-intl-next';

const _default_1: {
	highlightActionsPlaceholderPrompt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	highlightActionsPlaceholderPrompt: {
		id: 'highlight-actions.rovo-chat.placeholder-prompt',
		defaultMessage: 'Ask a question about this.',
		description: 'Placeholder prompt for highlight actions when Chat button is clicked',
	},
});
export default _default_1;
